// removed by extract-text-webpack-plugin
module.exports = {"Error":"InputError-module__Error__2T7V0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/InputError/InputError.module.css
// module id = 1693
// module chunks = 31